export default __webpack_public_path__ + "static/Fall8-e56be11c73ccf31d99ceafbb4b76268f.mp3";